import { Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AttachmentService } from 'src/services/attachment.service';

@Pipe({
  name: 'attach'
})
export class AttachmentPipe implements PipeTransform {

  constructor(private attachSvc: AttachmentService) {
  }

  transform(value: string, ...args: unknown[]) {
    if (!!value) {
      return this.attachSvc.get(value)
        .pipe(
          map((res) => { return res.fileName; })
        );
    } else {
      return of('없음');
    }
  }
}
